"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _SignInCardContent = _interopRequireDefault(require("./SignInCardContent"));

var SignInCardAttachment = function SignInCardAttachment(_ref) {
  var content = _ref.attachment.content,
      disabled = _ref.disabled;
  return /*#__PURE__*/_react.default.createElement(_SignInCardContent.default, {
    content: content,
    disabled: disabled
  });
};

SignInCardAttachment.defaultProps = {
  disabled: undefined
};
SignInCardAttachment.propTypes = {
  attachment: _propTypes.default.shape({
    content: _propTypes.default.any.isRequired
  }).isRequired,
  disabled: _propTypes.default.bool
};
var _default = SignInCardAttachment;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9hZGFwdGl2ZUNhcmRzL0F0dGFjaG1lbnQvU2lnbkluQ2FyZEF0dGFjaG1lbnQuanMiXSwibmFtZXMiOlsiU2lnbkluQ2FyZEF0dGFjaG1lbnQiLCJjb250ZW50IiwiYXR0YWNobWVudCIsImRpc2FibGVkIiwiZGVmYXVsdFByb3BzIiwidW5kZWZpbmVkIiwicHJvcFR5cGVzIiwiUHJvcFR5cGVzIiwic2hhcGUiLCJhbnkiLCJpc1JlcXVpcmVkIiwiYm9vbCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7O0FBQ0E7O0FBRUE7O0FBRUEsSUFBTUEsb0JBQW9CLEdBQUcsU0FBdkJBLG9CQUF1QjtBQUFBLE1BQWlCQyxPQUFqQixRQUFHQyxVQUFILENBQWlCRCxPQUFqQjtBQUFBLE1BQTRCRSxRQUE1QixRQUE0QkEsUUFBNUI7QUFBQSxzQkFDM0IsNkJBQUMsMEJBQUQ7QUFBbUIsSUFBQSxPQUFPLEVBQUVGLE9BQTVCO0FBQXFDLElBQUEsUUFBUSxFQUFFRTtBQUEvQyxJQUQyQjtBQUFBLENBQTdCOztBQUlBSCxvQkFBb0IsQ0FBQ0ksWUFBckIsR0FBb0M7QUFDbENELEVBQUFBLFFBQVEsRUFBRUU7QUFEd0IsQ0FBcEM7QUFJQUwsb0JBQW9CLENBQUNNLFNBQXJCLEdBQWlDO0FBQy9CSixFQUFBQSxVQUFVLEVBQUVLLG1CQUFVQyxLQUFWLENBQWdCO0FBQzFCUCxJQUFBQSxPQUFPLEVBQUVNLG1CQUFVRSxHQUFWLENBQWNDO0FBREcsR0FBaEIsRUFFVEEsVUFINEI7QUFJL0JQLEVBQUFBLFFBQVEsRUFBRUksbUJBQVVJO0FBSlcsQ0FBakM7ZUFPZVgsb0IiLCJzb3VyY2VSb290IjoiYnVuZGxlOi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgU2lnbkluQ2FyZENvbnRlbnQgZnJvbSAnLi9TaWduSW5DYXJkQ29udGVudCc7XG5cbmNvbnN0IFNpZ25JbkNhcmRBdHRhY2htZW50ID0gKHsgYXR0YWNobWVudDogeyBjb250ZW50IH0sIGRpc2FibGVkIH0pID0+IChcbiAgPFNpZ25JbkNhcmRDb250ZW50IGNvbnRlbnQ9e2NvbnRlbnR9IGRpc2FibGVkPXtkaXNhYmxlZH0gLz5cbik7XG5cblNpZ25JbkNhcmRBdHRhY2htZW50LmRlZmF1bHRQcm9wcyA9IHtcbiAgZGlzYWJsZWQ6IHVuZGVmaW5lZFxufTtcblxuU2lnbkluQ2FyZEF0dGFjaG1lbnQucHJvcFR5cGVzID0ge1xuICBhdHRhY2htZW50OiBQcm9wVHlwZXMuc2hhcGUoe1xuICAgIGNvbnRlbnQ6IFByb3BUeXBlcy5hbnkuaXNSZXF1aXJlZFxuICB9KS5pc1JlcXVpcmVkLFxuICBkaXNhYmxlZDogUHJvcFR5cGVzLmJvb2xcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFNpZ25JbkNhcmRBdHRhY2htZW50O1xuIl19